export default "__VITE_ASSET__yvK9oOPG__"